import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../ts/Glob';

type LogoPosition = 'left' | 'above' | 'full-left';

function ApplicationLogo(
    props: {
        position: LogoPosition;
        layoutType: string;
        widgetMode: boolean;
        distractFree: boolean;
        showAppLogo: boolean;
        glob: IGlob;
    },
    ref: React.ForwardedRef<HTMLDivElement>
) {
    props.glob.SettingsStore.useSimpleStoreStateHook();

    if (props.layoutType !== 'normal' || props.widgetMode) {
        return null;
    }

    if (!props.showAppLogo) {
        return null;
    }

    const logoPosition = props.glob.SettingsStore.getApplicationLogoPosition();

    if (logoPosition === 'noshow') {
        return null;
    }

    let logoState: LogoPosition;

    if (props.distractFree) {
        logoState = 'above';
    } else {
        switch (logoPosition) {
            case 'above':
                logoState = 'above';
                break;

            case 'leftFullHeight':
                logoState = 'full-left';
                break;

            default:
                logoState = 'left';
        }
    }

    if (logoState !== props.position) {
        return null;
    }

    const logo = props.glob.SettingsStore.getApplicationLogo();

    if (logo == null || logo === '') {
        return null;
    }

    let content;

    if (!props.glob.SettingsStore._state.app.loading) {
        content = { __html: logo };
    }

    return <div ref={ref} className={'application-logo ' + logoState} dangerouslySetInnerHTML={content} />;
}

export default React.forwardRef(ApplicationLogo);
